import { StyleSheet } from 'aphrodite'

import list from './list'
import group from './group'

import ColorBlind from './ColorBlind'

export default {
  list: StyleSheet.create(list),
  group: StyleSheet.create(group),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupTable/style/index.js